import * as actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  error: false,
  allowB: false,
  allowBB: false,
  showBalance: true,
  tipDostavki: 0,
  showSverkaMessage: false,
  user: {
    username: '',
    name: '',
    email: '',
    phone: '',
    skype: ''
  },
  managers: [],
  notifications: []
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
